export default __webpack_public_path__ + "c3ff0475124be480c46ef3a6608ee867.png";